import React from "react";

const ProcessingBar = () => {
  return (
    <>
      <span className="loader" />
      <style>{`
        .loader {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: block;
          margin: 10px auto;
          position: relative;
          animation: shadowPulse 1s linear infinite;
        }

        @keyframes shadowPulse {
          33% {
            background: #FFF;
            box-shadow: -24px 0 #A52126 24px 0 #FFF;
          }
          66% {
            background: #A52126;
            box-shadow: -24px 0 #FFF, 24px 0 #FFF;
          }
          100% {
            background: #FFF;
            box-shadow: -24px 0 #FFF, 24px 0 #A52126
          }
        }
      `}</style>
    </>
  );
};

export default ProcessingBar;
